<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
            <div class="totals-box order-boxs">
              <div class="detail">
                <div class="customTable">
                  <div class="box">
                    <div class="itemName">系统流水号</div>
                    <div class="itemNum">{{ form.id }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">交易流水号</div>
                    <div class="itemNum">{{ form.thirdOrderId }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">缴款月份</div>
                    <div class="itemNum">{{ formatMonth(form.dataMonth) }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">缴款金额</div>
                    <div class="itemNum">{{ form.amount }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">支付渠道</div>
                    <div class="itemNum">{{ form.payWayCn }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">支付状态</div>
                    <div class="itemNum">{{ form.payStatusCn }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">来源</div>
                    <div class="itemNum">{{ form.transferSourceCn }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">操作人</div>
                    <div class="itemNum">{{ form.oxCuname }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">缴款时间</div>
                    <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">备注</div>
                    <div class="itemNum">{{ form.remark }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">审核状态</div>
                    <div class="itemNum">{{ form.auditStatusCn }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">审核时间</div>
                    <div class="itemNum">{{ formatDate(form.auditTime) }}</div>
                  </div>
                  <div class="box">
                    <div class="itemName">审核备注</div>
                    <div class="itemNum">{{ form.auditRemark }}</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
          <div>
            <el-button
              v-if="form.cancelFlag"
              class="ml10 small-btn"
              type="warning"
              @click="undo"
            >撤销</el-button>
            <el-button
              v-if="form.updateFlag"
              class="ml10 small-btn"
              type="primary"
              @click="updates"
            >修改</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <edit ref="editForm" @change="editChange"></edit>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import edit from "./edit.vue"
export default {
  mixins: [minxin],
  components: {
    drawer,
    edit
  },
  props: {},
  data() {
    return {
      addEditShow: false,
      addEditTitle: "缴款详情",
      dialogHide: false,
      form: {
        orderType: ""
      },
      dialogHide: false,
      isRefrse: false
    };
  },
  created() {
    this.init();
  },
  mounted() {
   
  },
  destroy() {
    
  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.fundTransferSum.fundTransferOrderGet, {
            id: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
            }
          }).catch(error => {});
      });
    },

    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    undo() {
      
      this.$confirm("确定撤销吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.fundTransferSum.cancel + '?id=' + this.form.id)
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    updates(status) {
      // 修改
     this.$refs["editForm"].$emit("set", this.form.id)
    },
    editChange (org) {
      if (org) {
        this.isRefrse = true;
        this.$api.get(this.$url.fundTransferSum.fundTransferOrderGet, {
          id: this.form.id
        }).then(res => {
          if (res) {
            this.form = res;
          }
        }).catch(error => {});
      }
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", this.isRefrse);
    }
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  border-top: 10px solid @borderColor;
  .order-title-boxs {
    border-top: 10px solid @borderColor;
  }
  .titles-head {
    border-top: 0;
  }
  .totals-box {
    // padding: 0.2rem 0;
   
    .detail {
      padding: 0;
      font-size: 1rem;
      .rows {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        p {
          &:first-child {
            min-width: 90px;
          }
          &:last-child {
            text-align: right;
          }
        }
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  
  .order-boxs {
    .customTable {
      .box {
        height: 46px;
        .decoration {
          text-decoration: line-through;
        }
        .itemNum {
          font-size: 18px;
        }
        .itemName {
          color: #333;
        }
      }
    }
  }
  .order_title {
    display: flex;
    justify-content: space-between;
    padding-right: 26px;
    i {
      font-style: normal;
      &:last-child {
        color: #8d8d8d;
      }
    }
  }
  .org-title {
    border-top: 10px solid @borderColor;
  }
  .pay-methods {
    padding: 0.3rem;
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }
    .active {
      background-image: url("../../../assets/images/money/gou.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: @blue;
    }
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      .money {
        color: #f40;
      }
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>